import {useContext} from "react";
import {StoreContext} from "../store/appContext";

export const useStore = () => useContext(StoreContext);
